import React, { ReactElement } from "react";
import { get } from "lodash";
import { v4 as generateUUID } from "uuid";
// @ts-ignore
import StoryblokService from "@fdr-mar/storyblok-promos-bridge";
import Text from "@fdr/atomic-ui/_atoms/Text";
import { RichText, RichTextInlineComp } from "@fdr-mar/promos-types/Storyblok";

import OptinButton, { OptinButtonProps } from "../OptinButton";

const storyblok = new StoryblokService();

interface ComponentsDictionary {
  [key: string]: React.ComponentType<OptinButtonProps>;
}

let COMPONENTS_DICTIONARY: ComponentsDictionary = Object.create(null);

COMPONENTS_DICTIONARY = {
  // @ts-ignore
  optin_button: OptinButton
};

/* eslint-disable no-underscore-dangle */

export const RenderRichTextInlineComp = (
  blok: RichTextInlineComp
): ReactElement => {
  const elem = get(blok, "attrs.body[0]", { component: blok });

  if (elem && typeof COMPONENTS_DICTIONARY[elem.component] !== "undefined") {
    return React.createElement(COMPONENTS_DICTIONARY[elem.component], {
      key: elem._uid,
      content: elem,
      isStaticPromo: false
    });
  }

  return React.createElement(
    () => (
      <div>
        The component {elem.component.type} is not configured on rich text
        editor.
      </div>
    ),
    { key: elem._uid }
  );
};

export const RenderRichTextParagraph = (
  blok: RichText
): ReactElement | string => {
  // If rich text editor has a paragraph with no text we want to have br being rendered
  if (typeof blok.content === "undefined") {
    return "<br />";
  }

  const uniqueId = generateUUID();

  switch (blok.type) {
    case "heading":
    case "blockquote":
    case "ordered_list":
    case "bullet_list":
    case "horizontal_rule":
    case "paragraph":
      return storyblok.richText(blok);
    case "code_block":
    default:
      return (
        <Text tag="div" key={uniqueId}>
          {`Support not enabled for ${blok.type}`}
        </Text>
      );
  }
};
